module.exports = __webpack_public_path__ + "img/adminServiceInfo2_back_2023_10_04.8c152aa9.png";